import styled from "styled-components";
import {SearchMatchDefaultBox} from "./search-match.default.box";

export const SearchMatchMrGreenBox = styled(SearchMatchDefaultBox)`
      color: ${props => props.theme.colors.textActive}
`;
